import { Badge } from '@components/primitives/Badge'
import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import { Text } from '@components/primitives/Text'
import { type ColorGroup } from '@lib/colors/colors'

export type PatientProps = {
  age: string
  badge: string
  colorGroup: ColorGroup
  condition: string
  img: string
  location: string
  name: string
  tag: string
}

export const PatientRequestCard = ({
  age,
  badge,
  colorGroup,
  condition,
  img,
  location,
  name,
  tag,
}: PatientProps) => {
  return (
    <div className='flex w-full justify-between rounded-2xl border border-neutral200 bg-neutral100 p-4'>
      <div className='flex items-center gap-4'>
        <div className='size-24'>
          <CloudflareImage
            alt={'Patient Requesting Trial'}
            className={'object-cover'}
            height={192}
            imageId={img}
            width={192}
          />
        </div>
        <div>
          <Text
            className='mb-2 leading-6 text-neutral800'
            element='p'
            styleName='p-strong'
            value={
              <>
                {name} is looking for
                <br />
                <span className='text-primary600'> {condition} </span>
                trials
              </>
            }
          />
          <Text
            className='text-neutral600'
            element='p'
            styleName='p-tiny'
            value={`${location} · ${age} yrs old · ${tag}`}
          />
        </div>
      </div>

      <div className='flex items-center'>
        <Badge
          className='rounded-full'
          colorGroup={colorGroup}
          label={badge}
          variant='accent'
        />
      </div>
    </div>
  )
}
